import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    bannerHeight: "", // 自适应高度
    schemeList: {},   // 解决方案数据
    activePath: "",   // 激活菜单项
    mea_state: false, // 测量激活状态 
};
const store = new Vuex.Store({
    state,
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js